// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var JsxRuntime = require("react/jsx-runtime");
var Nps$ReactHooksTemplate = require("./Nps.res.js");
var CustomerInfo$ReactHooksTemplate = require("./CustomerInfo.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var MandatoryMessage$ReactHooksTemplate = require("./MandatoryMessage.res.js");
var NpsSquareBoxForm$ReactHooksTemplate = require("./NpsSquareBoxForm.res.js");
var NpsRoundedBoxForm$ReactHooksTemplate = require("./NpsRoundedBoxForm.res.js");
var NpsConfigurableForm$ReactHooksTemplate = require("./NpsConfigurableForm.res.js");
var QuestionTextPreview$ReactHooksTemplate = require("./QuestionTextPreview.res.js");
var NpsRoundedBoxWithSmileyForm$ReactHooksTemplate = require("./NpsRoundedBoxWithSmileyForm.res.js");
var NpsGradientScaleWithSmileyForm$ReactHooksTemplate = require("./NpsGradientScaleWithSmileyForm.res.js");

function NpsPreview(props) {
  var onChange = props.onChange;
  var mandatory = props.mandatory;
  var language = props.language;
  var surveyTheme = props.surveyTheme;
  var customerInfo = props.customerInfo;
  var nps = props.nps;
  var substitutionVariables = Belt_Option.getWithDefault(props.substitutionVariables, {});
  var componentType = Belt_Option.getWithDefault(Nps$ReactHooksTemplate.componentType(nps), "rounded_box_with_smiley");
  var onTitleChange = function (html) {
    Curry._1(onChange, Nps$ReactHooksTemplate.setText(nps, html));
  };
  var onDescriptionChange = function (html) {
    Curry._1(onChange, Nps$ReactHooksTemplate.setDescription(nps, html));
  };
  var borderCss = "";
  var configuration = Nps$ReactHooksTemplate.configuration(nps);
  var scaleContent;
  switch (componentType) {
    case "custom" :
        scaleContent = JsxRuntime.jsx(NpsConfigurableForm$ReactHooksTemplate.make, {
              nps: nps,
              customerInfo: customerInfo,
              language: language,
              mandatory: mandatory,
              onChange: onChange,
              borderCss: borderCss,
              configuration: configuration,
              contentOnly: true,
              substitutionVariables: substitutionVariables
            });
        break;
    case "gradient_scale_with_smiley" :
        scaleContent = JsxRuntime.jsx(NpsGradientScaleWithSmileyForm$ReactHooksTemplate.make, {
              nps: nps,
              customerInfo: customerInfo,
              surveyTheme: surveyTheme,
              language: language,
              mandatory: mandatory,
              onChange: onChange,
              borderCss: borderCss,
              configuration: configuration,
              contentOnly: true,
              substitutionVariables: substitutionVariables
            });
        break;
    case "rounded_box" :
        scaleContent = JsxRuntime.jsx(NpsRoundedBoxForm$ReactHooksTemplate.make, {
              nps: nps,
              customerInfo: customerInfo,
              language: language,
              mandatory: mandatory,
              onChange: onChange,
              borderCss: borderCss,
              configuration: configuration,
              contentOnly: true,
              substitutionVariables: substitutionVariables
            });
        break;
    case "square_box" :
        scaleContent = JsxRuntime.jsx(NpsSquareBoxForm$ReactHooksTemplate.make, {
              nps: nps,
              customerInfo: customerInfo,
              surveyTheme: surveyTheme,
              language: language,
              mandatory: mandatory,
              onChange: onChange,
              borderCss: borderCss,
              configuration: configuration,
              contentOnly: true,
              substitutionVariables: substitutionVariables
            });
        break;
    default:
      scaleContent = JsxRuntime.jsx(NpsRoundedBoxWithSmileyForm$ReactHooksTemplate.make, {
            nps: nps,
            customerInfo: customerInfo,
            language: language,
            mandatory: mandatory,
            onChange: onChange,
            borderCss: borderCss,
            configuration: configuration,
            contentOnly: true,
            substitutionVariables: substitutionVariables
          });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(QuestionTextPreview$ReactHooksTemplate.make, {
                      text: Nps$ReactHooksTemplate.getTextTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)).replace("${RM_NAME}", CustomerInfo$ReactHooksTemplate.rmName(customerInfo)),
                      description: Nps$ReactHooksTemplate.getDescriptionTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)),
                      onTitleChange: onTitleChange,
                      onDescriptionChange: onDescriptionChange
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Scale",
                              className: "text-aurometalsaurus text-sm mb-2 font-normal"
                            }),
                        JsxRuntime.jsx("div", {
                              children: scaleContent,
                              className: "flex"
                            })
                      ],
                      className: "flex flex-col"
                    }),
                mandatory ? JsxRuntime.jsx(MandatoryMessage$ReactHooksTemplate.make, {
                        language: language
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ],
              className: "w-full p-16"
            });
}

var make = NpsPreview;

exports.make = make;
/* react/jsx-runtime Not a pure module */
